import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { CommendaServiceOptions } from './types';

export function useCommendaServiceOptions() {
  const { data, error }: { data?: CommendaServiceOptions; error?: unknown } =
    useSWR('commenda-services/options', SWRFetcher({ method: 'GET' }));

  return { data, error, isLoading: !data && !error };
}
